import { useElementBox, useElementRender, type ElementComponent } from './elementRenderContext';
import { numberProp } from './elementProps';
import { SocialIcons } from './SocialIcons';

// The store's social profiles as a row of icons, read from Settings › General, so a merchant types each
// address once and every theme that draws them stays in step. A shopper sees only the networks the
// store filled in; inside the builder an empty row says where to fill them.

// Draws the store's social profiles as icons, or in the builder where to add them while there are none.
export const SocialLinksElement: ElementComponent = ({ node }) => {
  const box = useElementBox(node);
  const { editing, store } = useElementRender();
  const links = store?.social ?? [];
  if (links.length === 0) {
    return editing ? <p {...box} className={[box.className, 'xe-social-note'].filter(Boolean).join(' ')}>Add your social links under Settings › General › Social media.</p> : null;
  }
  return <SocialIcons {...box} links={links} storeName={store?.storeName ?? ''} size={numberProp(node.props, 'size', 22)} />;
};
